export const features = {
  PROMO_CODES: 'promoCodes',
  USER_ROLES: 'userRoles',
  USERS: 'users',
  RATE_SETTINGS: 'rateSettings',
  ENFORCEMENT: 'enforcement',
  REFUND_PORTAL: 'refundPortal',
  REAL_TIME_DASHBOARD: 'realTimeDashboard',
  SETTLED_DASHBOARD: 'settledDashboard',
  LOCATION: 'location',
  BULK_GENERATION: 'bulkGeneration',
  PARKING_PASSES: 'parkingPasses',
};

export const shortFeatureNames = {
  promoCodes: 'pc',
  userRoles: 'ur',
  users: 'u',
  rateSettings: 'rs',
  enforcement: 'e',
  refundPortal: 'rp',
  real_time_dashboard: 'rd',
  settledDashboard: 'sd',
  location: 'lo',
  bulkGeneration: 'bg',
  parkingPasses: 'pp',

  PROMO_CODES: 'pc',
  USER_ROLES: 'ur',
  USERS: 'u',
  RATE_SETTINGS: 'rs',
  ENFORCEMENT: 'e',
  REFUND_PORTAL: 'rp',
  REAL_TIME_DASHBOARD: 'rd',
  SETTLED_DASHBOARD: 'sd',
  LOCATION: 'lo',
  BULK_GENERATION: 'bg',
  PARKING_PASSES: 'pp',
};

export const access = {
  CAN_VIEW: 'canView',
  CAN_ADD: 'canAdd',
  CAN_EDIT: 'canEdit',
  CAN_DELETE: 'canDelete',
};

export const shortAccess = {
  [access.CAN_VIEW]: 'v',
  [access.CAN_ADD]: 'a',
  [access.CAN_EDIT]: 'e',
  [access.CAN_DELETE]: 'd',
};
